import { Columns2, LayoutGrid, Square, type LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import type { RowLayout } from '@/lib/schema.types';

export interface RowLayoutOption {
  layout: RowLayout;
  label: string;
  description: string;
  preview: ReactNode;
  icon: LucideIcon;
}

/** The blank-slide options shown at the top of the "Add new slide" picker. */
export const ROW_LAYOUT_OPTIONS: RowLayoutOption[] = [
  {
    layout: 1,
    label: '1 column',
    description: 'Full-width content',
    icon: Square,
    preview: (
      <div className="flex h-full w-full items-center justify-center p-3">
        <div className="h-full w-full rounded-sm bg-fg-subtle/30" />
      </div>
    ),
  },
  {
    layout: 2,
    label: '2 columns',
    description: 'Side-by-side split',
    icon: Columns2,
    preview: (
      <div className="flex h-full w-full items-center justify-center gap-1.5 p-3">
        <div className="h-full flex-1 rounded-sm bg-fg-subtle/30" />
        <div className="h-full flex-1 rounded-sm bg-fg-subtle/30" />
      </div>
    ),
  },
  {
    layout: 3,
    label: '3 columns',
    description: 'Three-column grid',
    icon: LayoutGrid,
    preview: (
      <div className="flex h-full w-full items-center justify-center gap-1.5 p-3">
        <div className="h-full flex-1 rounded-sm bg-fg-subtle/30" />
        <div className="h-full flex-1 rounded-sm bg-fg-subtle/30" />
        <div className="h-full flex-1 rounded-sm bg-fg-subtle/30" />
      </div>
    ),
  },
];
